import { CheckCircle } from '@mui/icons-material';
import { CSSTransition } from 'react-transition-group';

import { timing } from 'config/theme';
import { useCandidateContext } from 'hooks';

import { SubmittedWrapper } from './styledComponents';

export const Submitted = () => {
  const { submitted, toggleSubmitted } = useCandidateContext();
  return (
    <SubmittedWrapper>
      <CSSTransition
        in={submitted}
        timeout={{
          enter: timing.submitted.beg,
          exit: timing.submitted.mid + timing.submitted.end,
        }}
        classNames='submit-transition'
        onEntered={toggleSubmitted}
      >
        <div>
          <div>
            <CheckCircle sx={{ fontSize: '70px' }} />
            <span>Candidate information submitted.</span>
          </div>
        </div>
      </CSSTransition>
    </SubmittedWrapper>
  );
};
